import React from 'react'
import Modal from '../Modal'
import { Content } from './styles'
import Text from '../Text'
import ValidatePasswordForm from '../../forms/ValidatePassword'

interface Props {
  title: string
  onValidation: () => void
  onCancel: () => void
}

const ValidatePassword: React.FC<Props> = ({
  title,
  onValidation,
  onCancel,
}) => {
  return (
    <Modal
      open
      small
      onToggle={() => onCancel()}
    >
      <Content>
        <Text
          tag="h2"
          align="center"
        >
          {title}
        </Text>
        <ValidatePasswordForm
          onSubmit={() => onValidation()}
        />
      </Content>
    </Modal>
  )
}

export default ValidatePassword
